export enum DisplayCurrency{
    code='code',
    symbol='symbol',
    symbolNarrow = 'symbol-narrow'
}